// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HkvJ","signatureBlock":"Footer_signatureBlock__1oIQs","signature":"Footer_signature__3HOJM"};